// "The winery <name> has been added to the catalogue": the in-app side of the push the edge sends
// when druif has imported a winery the user typed in. A dismissible strip of Button atoms,
// shown on the landing screens only and never over another strip, so it is the fallback for a
// device with push off or denied and a second chance for one with it on.
import { useCataloguePrompt } from "../lib/catalogue";
import { dismissNotice, noticePath, useWineryNotice } from "../lib/contribute/notices";
import { useT } from "../lib/i18n";
import { navigate, useRoute } from "../lib/router";
import { Banner, Button, Row } from "../ui";

const LANDING = new Set(["", "taste", "search", "cellar"]);

export function WineryNotice(): React.JSX.Element | null {
  const { t } = useT();
  const notice = useWineryNotice();
  const route = useRoute();
  const catalogueShowing = useCataloguePrompt() !== undefined;
  if (notice === undefined || catalogueShowing) return null;
  if (!LANDING.has(route.segments[0] ?? "") || route.segments.length > 1) return null;

  return (
    <Banner
      data-testid="winery-notice"
      position="fixed"
      top="max(12px, env(safe-area-inset-top))"
      left="5"
      right="5"
      maxWidth={640}
      marginHorizontal="auto"
      zIndex="5"
      boxShadow="var(--shSheet)"
      message={t("notice.winery.added", { name: notice.producer.name })}
    >
      <Row gap="2">
        <Button
          tone="primary"
          data-testid="winery-notice-open"
          onPress={() => {
            dismissNotice(notice);
            navigate(noticePath(notice));
          }}
        >
          {t("notice.winery.open")}
        </Button>
        <Button
          tone="ghost"
          data-testid="winery-notice-close"
          onPress={() => {
            dismissNotice(notice);
          }}
        >
          {t("notice.winery.close")}
        </Button>
      </Row>
    </Banner>
  );
}
